import { AxnSession, FormattedAxnSession } from "@idw-types/data/management-console/axn";

export const formatAxnSessions = (sessions: Array<AxnSession>): Array<FormattedAxnSession> => {
    return sessions.map(session => formatAxnSession(session));
};

export const formatAxnSession = (session: AxnSession): FormattedAxnSession => {
    let date = null;
    if (session.date) {
        date = new Date(parseInt(session.date));
    }
    return {
        apiKey: session.apiKey,
        asi: session.asi,
        credential: session.credential,
        date: date,
        mbun: session.mbun,
        relyingParty: session.relyingParty
    };
};